import { Box, Text } from "@chakra-ui/react";
/**
 * @typedef {Object} Props
 * @property {string} title
 * @property {import("react").ReactNode} children
 */
/**
 * @param {Props} props
 */
export function Section({ title, children }) {
  return (
    <Box>
      <Text variant="h3">{title}</Text>

      <Box h="1px" backgroundColor="brandPrimary.500" mt="12px" />

      <Box mt="16px">{children}</Box>
    </Box>
  );
}
